import { library } from '@fortawesome/fontawesome-svg-core'

import { faEdit } from '@fortawesome/pro-solid-svg-icons/faEdit'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faChartBar } from '@fortawesome/pro-solid-svg-icons/faChartBar'
import { faChartPie } from '@fortawesome/pro-solid-svg-icons/faChartPie'
import { faChartLine } from '@fortawesome/pro-solid-svg-icons/faChartLine'
import { faEuroSign } from '@fortawesome/pro-solid-svg-icons/faEuroSign'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft'
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight'
import { faAngleUp } from '@fortawesome/pro-solid-svg-icons/faAngleUp'
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'
import { faTable } from '@fortawesome/pro-solid-svg-icons/faTable'
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt'

library.add(
  faEdit, faPlus, faChartBar, faChartPie, faChartLine, faEuroSign, faTimes, faAngleLeft, faAngleRight, faAngleUp,
  faAngleDown, faUser, faTable, faCalendarAlt
)
